// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Mf3j","content":"styles_content__1Do06","row":"styles_row__esQAC","footer":"styles_footer__32Zgw","phraseLength":"styles_phraseLength__3HrNr"};